import { root } from '../../../../../store/constants';
import { ThunkAction, Dispatch } from '../../../../../types/actions';

export const closeUpdatesTips = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        root.App.controller.updatesTipsView.remove();
    };
    return action;
};
